<template>
  <div id="App">
    <van-nav-bar :title="title" />
    <van-list
      style="margin-top:-15px;"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-divider />
      <van-cell
        v-for="item in list"
        :key="item.CODE"
        :title="item.NAME"
        is-link
        size="large"
        @click="onClickCell(item)"
      />
    </van-list>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Tabbar from "@/components/Tabbar.vue";
import { Dialog } from "vant";
export default {
  data() {
    return {
      title: "人员管理",
      list: [],
      loading: false,
      finished: false
    };
  },
  components: {
    Tabbar
  },
  computed: {
    ...mapState(["userInfo"])
  },
  methods: {
    onClickCell(key) {
      this.$store.commit("setTempQuery", {
        Code: key.CODE,
        Name: key.NAME
      });
      this.$router.push({
        path: "/SelWorkerTeam",
        name: "SelWorkerTeam"
      });
    },
    onLoad() {
      this.loading = true;
      var that = this;
      that
        .$axios({
          method: "post",
          url: "/api/Main",
          data: {
            Method: "GetWechatProList",
            Params: [that.userInfo.userCardID, that.userInfo.loginType, "1"]
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            that.list = response.data.Table;
            that.finished = true;
          } else {
            Dialog({ message: response.data.msg });
            that.finished = true;
          }
        })
        .catch(error => {
          window.console.log(error);
          //弹出失败提醒
          Dialog({ message: error.message });
          that.finished = true;
        });
    }
  }
};
</script>
